import { AxiosResponse } from "axios";
import { ICarrossel } from "../interfaces/model/iCarrossel";
import { api } from "./api";

const url = "carrosel/";

const getAll = (): Promise<AxiosResponse<ICarrossel[]>> => {
  return api.get(url);
};

const create = (carrossel: ICarrossel): Promise<AxiosResponse<ICarrossel>> => {
  return api.post(url, carrossel);
};

const update = (
  id: number,
  carrossel: ICarrossel
): Promise<AxiosResponse<ICarrossel>> => {
  return api.put(`${url}${id}`, carrossel);
};

const remove = (id: number): Promise<AxiosResponse<void>> => {
  return api.delete(`${url}${id}`);
};

const carrosselService = {
  getAll,
  create,
  update,
  remove,
};

export default carrosselService;
